function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { highlightedHourlyRecordsShape } from 'shapes/bins';
import App from 'modules/App';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './Statistics.pcss';
var _React_Component;
class Statistics extends (_React_Component = React.Component) {
    renderTimeLabel(minutes) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                "(",
                !!Math.floor(minutes / 60) && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        Math.floor(minutes / 60),
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.h))
                    ]
                }),
                " ",
                !!(minutes % 60) && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        Math.round(minutes % 60),
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.min))
                    ]
                }),
                !Math.floor(minutes / 60) && !(minutes % 60) && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        0,
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.min))
                    ]
                }),
                ")"
            ]
        });
    }
    renderGlucoseManagementIndicator() {
        const { conversion, highlightedAverageGlucose } = this.props;
        if (!highlightedAverageGlucose) {
            return ' - %';
        }
        if (conversion.unitSymbol === App.constants.UNITS_SYMBOLS.MG_DL) {
            return `${(3.31 + highlightedAverageGlucose * 0.02392).toPrecision(2)}%`;
        }
        if (conversion.unitSymbol === App.constants.UNITS_SYMBOLS.MMOL_L) {
            return `${(3.31 + highlightedAverageGlucose * 0.43099).toPrecision(2)}%`;
        }
        return '';
    }
    render() {
        const { conversion, standards, highlightedDates, statistics, highlightedTimeIsActive, highlightedAverageGlucose, highlightedCoefficientOfVariation, overwriteClassName } = this.props;
        if (!highlightedDates.length) return null;
        const startTime = moment(highlightedDates[0], 'YYYY-MM-DD');
        const endTime = moment(highlightedDates[highlightedDates.length - 1], 'YYYY-MM-DD');
        return /*#__PURE__*/ _jsxs("div", {
            className: overwriteClassName || styles.cgmStatistics,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "statisticsSection",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "statisticsSection__row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__label",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__elementHighlight",
                                        children: [
                                            startTime.format('DD  MMM YYYY'),
                                            ' - ',
                                            endTime.format('DD  MMM YYYY')
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__value",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__elementHighlight",
                                        children: [
                                            endTime.diff(startTime, 'days') + 1,
                                            " ",
                                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.days))
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "statisticsSection__row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__label",
                                    children: /*#__PURE__*/ _jsx("p", {
                                        className: "statisticsSection__elementHighlight",
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.timeCgmActive))
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__value",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__elementHighlight",
                                        children: [
                                            highlightedTimeIsActive ? highlightedTimeIsActive.toPrecision(3) : '- ',
                                            "%"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "statisticsSection",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "statisticsSection__row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__label",
                                    children: /*#__PURE__*/ _jsx("p", {
                                        className: "statisticsSection__elementHighlight",
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.glucoseRanges))
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__value",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__elementHighlight",
                                        children: [
                                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.targets)),
                                            " ",
                                            /*#__PURE__*/ _jsxs("span", {
                                                className: "statisticsSection__element",
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.percentOfReadings))
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "statisticsSection__row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__label",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__element",
                                        children: [
                                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.targetRange)),
                                            " ",
                                            `${conversion.toDisplay(standards.postMeal.lowThreshold)} - ${conversion.toDisplay(standards.postMeal.highThreshold)}`,
                                            " ",
                                            conversion.unitSymbol
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__value",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__element",
                                        children: [
                                            Math.round(statistics.target * 100),
                                            "%  ",
                                            this.renderTimeLabel(statistics.target * 1440)
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "statisticsSection__row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__label",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__element",
                                        children: [
                                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.below)),
                                            " ",
                                            conversion.toDisplay(standards.postMeal.lowThreshold),
                                            " ",
                                            conversion.unitSymbol
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__value",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__element",
                                        children: [
                                            Math.round(statistics.low * 100),
                                            "%  ",
                                            this.renderTimeLabel(statistics.low * 1440)
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "statisticsSection__row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__label",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__element",
                                        children: [
                                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.below)),
                                            " ",
                                            conversion.toDisplay(54),
                                            " ",
                                            conversion.unitSymbol
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__value",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__element",
                                        children: [
                                            Math.round(statistics.veryLow * 100),
                                            "%  ",
                                            this.renderTimeLabel(statistics.veryLow * 1440)
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "statisticsSection__row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__label",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__element",
                                        children: [
                                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.above)),
                                            " ",
                                            conversion.toDisplay(standards.postMeal.highThreshold),
                                            " ",
                                            conversion.unitSymbol
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__value",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__element",
                                        children: [
                                            Math.round(statistics.high * 100),
                                            "%  ",
                                            this.renderTimeLabel(statistics.high * 1440)
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "statisticsSection__row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__label",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__element",
                                        children: [
                                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.above)),
                                            " ",
                                            conversion.toDisplay(250),
                                            " ",
                                            conversion.unitSymbol
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__value",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__element",
                                        children: [
                                            Math.round(statistics.veryHigh * 100),
                                            "%  ",
                                            this.renderTimeLabel(statistics.veryHigh * 1440)
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "statisticsSection__row",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "statisticsSection__label",
                                children: /*#__PURE__*/ _jsx("p", {
                                    className: "statisticsSection__elementCaption",
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.increaseCaption))
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "statisticsSection",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "statisticsSection__row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__label",
                                    children: /*#__PURE__*/ _jsx("p", {
                                        className: "statisticsSection__elementHighlight",
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.averageGlucose))
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__value",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__elementHighlight",
                                        children: [
                                            highlightedAverageGlucose ? conversion.toDisplay(highlightedAverageGlucose) : '- ',
                                            " ",
                                            conversion.unitSymbol
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "statisticsSection__row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__label",
                                    children: /*#__PURE__*/ _jsx("p", {
                                        className: "statisticsSection__elementHighlight",
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.glucoseManagementIndicator))
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__value",
                                    children: /*#__PURE__*/ _jsx("p", {
                                        className: "statisticsSection__elementHighlight",
                                        children: this.renderGlucoseManagementIndicator()
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "statisticsSection__row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__label",
                                    children: /*#__PURE__*/ _jsx("p", {
                                        className: "statisticsSection__elementHighlight",
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.glucoseVariability))
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "statisticsSection__value",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: "statisticsSection__elementHighlight",
                                        children: [
                                            highlightedCoefficientOfVariation ? highlightedCoefficientOfVariation.toPrecision(3) : '- ',
                                            "%"
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "statisticsSection__row",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "statisticsSection__label",
                                children: /*#__PURE__*/ _jsx("p", {
                                    className: "statisticsSection__elementCaption",
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.definedAsPercentCaption))
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
_define_property(Statistics, "propTypes", {
    // Implicit props
    highlightedHourlyRecords: highlightedHourlyRecordsShape,
    highlightedDates: PropTypes.arrayOf(PropTypes.string),
    highlightedRecords: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.number
    })),
    highlightedTimeIsActive: PropTypes.number,
    highlightedAverageGlucose: PropTypes.number,
    highlightedCoefficientOfVariation: PropTypes.number,
    // Explicit props
    overwriteClassName: PropTypes.string,
    conversion: PropTypes.object.isRequired,
    statistics: PropTypes.shape({
        veryHigh: PropTypes.number,
        high: PropTypes.number,
        target: PropTypes.number,
        low: PropTypes.number,
        veryLow: PropTypes.number
    }),
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    direction: PropTypes.string
});
const mapStateToProps = (state, props)=>({
        dailyRecords: selectors.dailyRecords(state),
        highlightedDates: selectors.highlightedDates(state),
        highlightedRecords: selectors.highlightedRecords(state),
        statistics: selectors.highlightedStatisticsFactory(props.standards)(state),
        highlightedTimeIsActive: selectors.highlightedTimeIsActive(state),
        highlightedAverageGlucose: selectors.highlightedAverageGlucose(state),
        highlightedCoefficientOfVariation: selectors.highlightedCoefficientOfVariation(state),
        direction: App.selectors.direction(state)
    });
const ConnectedStatistics = connect(mapStateToProps)(Statistics);
export default withStyles(styles)(ConnectedStatistics);
